<script>
    import {fade, fly} from 'svelte/transition';
    import {clickOutside} from "../../lib/clickOutside";
    import {createEventDispatcher} from 'svelte/internal';
    import {onDestroy} from 'svelte';
    import CloseButton from "../../components/CloseButton.svelte";
    import AppIcon from "../icons/AppIcon.svelte";

    export let title = '';
    export let icon = null;
    export let modalMd = false;
    export let modalSm = false;

    export let modalLg = false;
    export let showCloseButton = true;
    export let closeOnClickOutside = false;
    export let closeOnEscape = false;
    export let visible = true;
    export let bodyClass = '';

    let nowState = false;

    const dispatch = createEventDispatcher();

    const handleClickOutside = () => {
        if (closeOnClickOutside) {
            close();
        }
    }

    const handleEscapeKey = event => {
        if (event.key === 'Escape') {
            event.preventDefault();
            event.stopPropagation();
            close();
        }
    }

    const close = () => {
        visible = false;
        setTimeout(() => {
            dispatch('close');
        }, 200);
    }

    onDestroy(() => {
        if (closeOnEscape) {
            document.removeEventListener('keydown', handleEscapeKey);
        }
    });

    $: if (nowState != visible && closeOnEscape) {
        if (visible) {
            document.addEventListener('keydown', handleEscapeKey);
            nowState = visible;
        }
    }
</script>
{#if visible}
    <div class="modal-overlay" transition:fade="{{ duration: 100 }}" use:clickOutside
         on:click_outside="{ handleClickOutside }">
        <div class="modal-wrapper">
            <div class="panel modal-panel" class:modal-sm={ modalSm } class:modal-md={ modalMd } class:modal-lg={modalLg}
                 in:fly="{{ y: -20, duration: 200 }}">
                <div class="panel-heading">
                    <div class="title">
                        {#if icon}
                            <AppIcon {icon} size="24" cssClass="me-3"/>
                        {/if}
                        { title }
                    </div>
                    {#if showCloseButton}
                        <CloseButton on:click="{ close }"/>
                    {/if}
                </div>
                <div class="panel-body { bodyClass }">
                    <slot name="body"/>
                </div>
                <slot name="footer"/>
            </div>
        </div>
    </div>
{/if}

<style>
    .modal-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.7);
        overflow-y: auto;
        z-index: 9000;
    }

    .modal-wrapper {
        position: absolute;
        display: flex;
        width: 100%;
        height: max-content;
        /*top: 0;*/
        /* left: 0; */
        /* right: 0; */
        /* bottom: 0; */
        /* width: max-content; */
        /* margin: auto; */
        align-items: center;
        justify-content: center;
        padding: 20px 0;
    }

    .modal-panel {
        /*position: absolute;*/
        /*top: 50%;*/
        /*left: 50%;*/
        /*transform: translateX(-50%) translateY(-50%);*/
        width: max-content;
        max-width: 80%;
        background: #fff;
        border-radius: 2px;
        /*overflow: hidden;*/
        transition: .3s all ease;
    }

    .modal-panel .panel-heading {
        padding: 20px;
    }

    .modal-panel .panel-heading .title {
        display: flex;
        align-items: center;
    }

    .modal-panel .panel-body {
        padding: 10px 20px 20px 20px;
    }

    .modal-lg {
        width: 100%;
    }

    .modal-md {
        width: 800px;
    }

    .modal-sm {
        width: calc(100% - 20px);
        max-width: 370px;
    }

    @media (min-width: 992px) {
        .modal-panel {
            min-width: 450px;
        }

        .modal-sm {
            min-width: unset;
        }
    }
</style>